import { useCompset } from "@/contexts/CompsetContext";
import { cn } from "@/lib/utils";
import * as Select from "@radix-ui/react-select";
import clsx from "clsx";
import { ChevronDown, Check } from "lucide-react";

export default function SelectCompset({
    value,
    onChange,
    activeIndicator = false,
    classNames = "",
    disableNonSelectable = false
}) {

    const { compsets } = useCompset();

    return (
        <Select.Root
            value={value}
            onValueChange={(value) => {
                onChange(value)
            }}
        >
            <Select.Trigger
                className={
                    cn(
                        "flex h-12 w-full items-center justify-between rounded-lg border px-4 text-sm outline-none bg-white",
                        classNames
                    )
                }
            >
                <Select.Value placeholder="Select Compset" />
                <Select.Icon>
                    <ChevronDown size={18} />
                </Select.Icon>
            </Select.Trigger>

            <Select.Portal>
                <Select.Content
                    position="popper"
                    side="bottom"
                    align="start"
                    sideOffset={6}
                    className="z-50 w-[var(--radix-select-trigger-width)] rounded-lg border bg-white shadow-lg"
                >
                    <Select.Viewport className="p-2">
                        {
                            compsets?.user_compsets?.length === 0 ? (
                                <Select.Item
                                    value="no-compset"
                                    disabled
                                    className="flex select-none items-center rounded-md py-2 pl-3 pr-4 text-sm text-gray-400 cursor-not-allowed"
                                >
                                    <Select.ItemText>No compset available</Select.ItemText>
                                </Select.Item>
                            ) :
                                compsets?.user_compsets?.map((compset, idx) => (
                                    <SelectItem
                                        activeIndicator={activeIndicator}
                                        value={compset?.compset_id}
                                        compset={compset}
                                        disableNonSelectable={disableNonSelectable}
                                    >
                                        {compset?.compset_name}
                                    </SelectItem>
                                ))
                        }
                    </Select.Viewport>
                </Select.Content>
            </Select.Portal>
        </Select.Root>
    );
}

function SelectItem({ children, value, activeIndicator, compset, disableNonSelectable }) {

    const disableStatus = disableNonSelectable
        ? compset?.has_data
        : false

    return (
        <Select.Item
            value={value}
            disabled={disableStatus}
            className={`relative flex cursor-pointer select-none items-center rounded-md py-2 ${activeIndicator ? 'pl-2' : "pl-8"} pr-4 text-sm outline-none hover:bg-gray-100 data-[state=checked]:bg-blue-50`}
        >
            <Select.ItemText>{children}</Select.ItemText>

            <Select.ItemIndicator className={`absolute ${activeIndicator ? "right-3" : "left-2"}`}>
                {
                    activeIndicator
                        ? <div className="min-w-2 min-h-2 rounded-full bg-green-700">  </div>
                        : <Check size={16} />
                }
            </Select.ItemIndicator>
        </Select.Item>
    );
}